import setupSteps from './setup-steps';
import fieldNames from './field-names';
import { serviceValues } from './fields-values';
import generateFieldKey from '../helpers/generate-field-key';

const project = generateFieldKey(setupSteps.PROJECT, fieldNames.SERVICE);

const newWebsiteDescription = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.BUILD_NEW_WEBSITE,
  fieldNames.NEW_WEBSITE_DESCRIPTION
);
const newWebsitePreparedContent = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.BUILD_NEW_WEBSITE,
  fieldNames.NEW_WEBSITE_CONTENT
);

const newWebsitePreparedContentTypes = generateFieldKey(
  newWebsitePreparedContent,
  fieldNames.NEW_WEBSITE_CONTENT_TYPES
);

const newWebsitePreparedContentOther = generateFieldKey(
  newWebsitePreparedContentTypes,
  fieldNames.NEW_WEBSITE_CONTENT_OTHER_TYPE
);

const newWebsiteExpectedFeatures = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.BUILD_NEW_WEBSITE,
  fieldNames.NEW_WEBSITE_EXPECTED_FEATURES
);

const revampWebsiteDescription = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.REVAMP_EXISTING_WEBSITE,
  fieldNames.WEBSITE_DESCRIPTION
);

const revampWebsiteExpectedImprovements = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.REVAMP_EXISTING_WEBSITE,
  fieldNames.WEBSITE_EXPECTED_IMPROVEMENTS
);

const migrationWebsiteUrl = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.MIGRATE_WEBSITE,
  fieldNames.MIGRATION_WEBSITE_URL
);

const migrationPlatform = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.MIGRATE_WEBSITE,
  fieldNames.MIGRATION_PLATFORM
);

const migrationPlatformOther = generateFieldKey(
  migrationPlatform,
  fieldNames.MIGRATION_PLATFORM_OTHER
);

const migrationReason = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.MIGRATE_WEBSITE,
  fieldNames.MIGRATION_REASON
);

const migrationReasonOther = generateFieldKey(migrationReason, fieldNames.MIGRATION_REASON_OTHER);

const migrationExpectedImprovements = generateFieldKey(
  setupSteps.DETAILS,
  serviceValues.MIGRATE_WEBSITE,
  fieldNames.MIGRATION_EXPECTED_IMPROVEMENTS
);

const contactInfoUserFullName = generateFieldKey(
  setupSteps.CONTACT_INFO,
  fieldNames.CONTACT_INFO_USER_FULL_NAME
);

const contactInfoUserEmail = generateFieldKey(
  setupSteps.CONTACT_INFO,
  fieldNames.CONTACT_INFO_USER_EMAIL
);

const contactInfoUserPhone = generateFieldKey(
  setupSteps.CONTACT_INFO,
  fieldNames.CONTACT_INFO_USER_PHONE
);

export const OTHER_FIELDS_ID = [
  newWebsitePreparedContentOther,
  migrationReasonOther,
  migrationPlatformOther,
];

export default {
  project,
  newWebsiteDescription,
  newWebsitePreparedContent,
  newWebsitePreparedContentTypes,
  newWebsitePreparedContentOther,
  newWebsiteExpectedFeatures,
  revampWebsiteDescription,
  revampWebsiteExpectedImprovements,
  migrationWebsiteUrl,
  migrationPlatform,
  migrationPlatformOther,
  migrationReason,
  migrationReasonOther,
  migrationExpectedImprovements,
  contactInfoUserFullName,
  contactInfoUserEmail,
  contactInfoUserPhone,
};
